import PropTypes from 'prop-types';

const ExclamationIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.0429806,35.4821764 C27.309891,35.4821764 29.9750022,38.2739212 29.9750022,41.7861163 C29.9750022,45.2082552 27.309891,48 24.0429806,48 C20.6900989,48 18.0249878,45.2082552 18.0249878,41.7861163 C18.0249878,38.2739212 20.6900989,35.4821764 24.0429806,35.4821764 Z M24.0429806,29.2682927 C21.8077262,29.2682927 20.2602423,27.3771107 20.0023283,25.0356473 L18.0249878,6.30393996 C17.6811025,3.0619137 20.9480129,4.61852778e-14 24.0429806,4.61852778e-14 C27.0519771,4.61852778e-14 30.3188875,3.0619137 29.9750022,6.30393996 L27.9976617,25.0356473 C27.7397477,27.3771107 26.1922638,29.2682927 24.0429806,29.2682927 Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  </div>
);

ExclamationIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ExclamationIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ExclamationIcon;
